/*
 * Sources:
 * - https://www.hcch.net/en/instruments/conventions/status-table/?cid=41
 * - https://www.iban.com/country-codes
 *
 * List of the numeric country codes contracting parties in the Apostille system
 */

import {
  CountryCodeType,
  EuCountries,
} from 'todistukset-common/src/vtj/EuCountries.enum'

export const ApostilleCountries: CountryCodeType = {
  ...EuCountries,
  ALBANIA: '008',
  ANDORRA: '020',
  ANTIGUA_AND_BARBUDA: '028',
  ARGENTINA: '032',
  ARMENIA: '051',
  AUSTRALIA: '036',
  AZERBAIJAN: '031',
  BAHAMAS: '044',
  BAHRAIN: '048',
  BARBADOS: '052',
  BELARUS: '112',
  BELIZE: '084',
  BOLIVIA: '068',
  BOSNIA_AND_HERZEGOVINA: '070',
  BOTSWANA: '072',
  BRAZIL: '076',
  BRUNEI: '096',
  BURUNDI: '108',
  CANADA: '124',
  CABO_VERDE: '132',
  CHILE: '152',
  CHINA: '156',
  COLOMBIA: '170',
  COOK_ISLANDS: '184',
  COSTA_RICA: '188',
  DOMINICA: '212',
  DOMINICAN_REPUBLIC: '214',
  ECUADOR: '218',
  EL_SALVADOR: '222',
  SWAZILAND: '748',
  FIJI: '242',
  GEORGIA: '268',
  GRENADA: '308',
  GUATEMALA: '320',
  GUYANA: '328',
  HONDURAS: '340',
  HONGKONG: '344',
  ICELAND: '352',
  INDIA: '356',
  INDONESIA: '360',
  ISRAEL: '376',
  JAMAICA: '388',
  JAPAN: '392',
  KAZAKHSTAN: '398',
  KOREA: '410',
  KOSOVO: '910', // Code taken from packages/vtj-koodisto/src/vtj/koodisto-manual-additions.ts
  KYRGYZSTAN: '417',
  LESOTHO: '426',
  LIBERIA: '430',
  LIECHTENSTEIN: '438',
  MACAO: '446',
  MALAWI: '454',
  MARSHALL_ISLANDS: '584',
  MAURITIUS: '480',
  MEXICO: '484',
  MONACO: '492',
  MONGOLIA: '496',
  MONTENEGRO: '499',
  MOROCCO: '504',
  NAMIBIA: '516',
  NEW_ZEALAND: '554',
  NICARAGUA: '558',
  NIUE: '570',
  NORWAY: '578',
  OMAN: '512',
  PALAU: '585',
  PANAMA: '591',
  PARAGUAY: '600',
  PERU: '604',
  MOLDOVA: '498',
  NORTH_MACEDONIA: '807',
  RUSSIAN_FEDERATION: '643',
  RWANDA: '646',
  SAINT_KITTS_AND_NEVIS: '659',
  SAINT_LUCIA: '662',
  SAINT_VINCENT_AND_GRENADINES: '670',
  SAMOA: '882',
  SAN_MARINO: '674',
  SAO_TOME_AND_PRINCIPE: '678',
  SAUDI_ARABIA: '682',
  SENEGAL: '686',
  SERBIA: '688',
  SEYCHELLES: '690',
  SINGAPORE: '702',
  SOUTH_AFRICA: '710',
  SURINAME: '740',
  SWITZERLAND: '756',
  TAJIKISTAN: '762',
  TONGA: '776',
  TRINIDAD_AND_TOBAGO: '780',
  TUNISIA: '788',
  TURKEY: '792',
  UKRAINE: '804',
  UNITED_KINGDOM: '826',
  UNITED_STATES: '840',
  URUGUAY: '858',
  UZBEKISTAN: '860',
  VANUATU: '548',
  VENEZUELA: '862',
}
